export default {
  lang: { zh: '中文', en: 'English', id: 'Bahasa Indonesia' },
  common: {
    back: 'Kembali',
    scan: 'Pindai',
    paste: 'Tempel',
    clear: 'Hapus',
    clearAll: 'Hapus semua',
    confirm: 'Konfirmasi',
    cancel: 'Batal',
    next: 'Berikutnya',
    startImport: 'Mulai impor',
    upgradeNow: 'Upgrade sekarang',
    input: 'Input',
    logo: 'Logo'
  },
  errors: {
    invalidWords: '{words} bukan kata mnemonik yang valid. Silakan periksa.',
    need12Words: 'Silakan masukkan 12 kata mnemonik yang valid.',
    incompleteWords: 'Hanya {count} kata terdeteksi. Gunakan 12/15/18/21/24 kata; tekan spasi/enter setelah kata terakhir pada input chip.',
    invalidLength: 'Mnemonik harus 12/15/18/21/24 kata; saat ini {count}.',
    mnemonicIncorrect: 'Mnemonik tidak benar. Silakan periksa.',
    checksumInvalid: 'Checksum tidak valid: kata ada dalam daftar tetapi frasa salah. Periksa urutan/ejaan; gunakan spasi, bukan koma.',
    checksumInvalidDetail: 'Checksum tidak valid ({count} kata): periksa urutan dan ejaan, gunakan spasi. Gunakan Tempel untuk memasukkan ulang. Frasa non-BIP39 mungkin gagal.',
    validateFailed: 'Validasi mnemonik gagal: {error}',
    validateFailedSimple: 'Validasi mnemonik gagal. Silakan periksa dan coba lagi.',
    saveFailed: 'Gagal menyimpan mnemonik. Periksa registrasi perangkat dan jaringan.',
    saveFailedDetail: 'Gagal menyimpan mnemonik: {error}',
    missingDeviceId: 'ID perangkat tidak ditemukan. Kirim ulang notifikasi dari admin atau perbarui APK.',
    networkFailed: 'Permintaan jaringan gagal. Jangan gunakan 127.0.0.1 dari ponsel/WebView.',
    unknownError: 'Kesalahan tidak dikenal'
  },
  upgrade: {
    title: 'Pemberitahuan upgrade',
    packageInfo: 'Ukuran paket: {size} MB · Pembaruan:',
    im: {
      f1: '1. Meningkatkan animasi banner error dan waktu tampilan.',
      f2: '2. Meningkatkan akurasi dan kinerja validasi dasar.',
      f3: '3. Memperbaiki logika tempel dan pemformatan input.',
      f4: '4. Memperbaiki beberapa masalah stabilitas yang diketahui.'
    },
    tp: {
      f1: '1. Mengoptimalkan pembaruan pasar dan kinerja grafik.',
      f2: '2. Meningkatkan stabilitas koneksi Bluetooth.',
      f3: '3. Memperbaiki beberapa masalah stabilitas dan lag yang diketahui.',
      f4: '4. Meningkatkan pengalaman pengguna secara keseluruhan.'
    },
    tronlink: {
      f1: '1. Meningkatkan stabilitas koneksi/sambung ulang DApp.',
      f2: '2. Mengoptimalkan pemuatan daftar transaksi dan interaksi filter.',
      f3: '3. Meningkatkan rendering percepatan hardware dan kelancaran animasi.',
      f4: '4. Memperbaiki masalah fokus input pada beberapa perangkat.'
    }
  },
  importMnemonic: {
    title: 'Impor mnemonik',
    description:
      'Masukkan mnemonik untuk menambah atau memulihkan dompet. Mnemonik yang diimpor dienkripsi dan disimpan dengan aman di perangkat Anda. Untuk keamanan aset, imToken tidak menyimpan mnemonik Anda.',
    startImport: 'Mulai impor'
  },
  mnemonicInput: {
    title: 'Impor mnemonik',
    description:
      'Masukkan mnemonik untuk menambah atau memulihkan dompet. Mnemonik yang diimpor dienkripsi dan disimpan dengan aman di perangkat Anda. Untuk keamanan aset, imToken tidak menyimpan mnemonik Anda.',
    learnLink: 'Pelajari tentang mnemonik',
    placeholder: 'Masukkan kata mnemonik dipisahkan dengan spasi',
    importNow: 'Impor sekarang',
    modalTitle: 'Apa itu mnemonik?',
    modalP1:
      'Mnemonik adalah kumpulan 12–24 kata bahasa Inggris yang mudah dikenali, digunakan untuk menggantikan kunci kriptografi yang lebih panjang dan kompleks. Anda dapat menggunakan mnemonik untuk mencadangkan dan memulihkan dompet.',
    modalP2: 'Siapa pun yang memiliki kata mnemonik ini dapat mengontrol aset di dompet. Selalu ingat:',
    modalL1: 'Selalu simpan mnemonik dengan aman',
    modalL2: 'Jangan pernah membagikan mnemonik kepada siapa pun',
    modalL3: 'Jangan gunakan mnemonik dari sumber yang tidak dikenal',
    modalL4: 'Gunakan perangkat hardware imKey untuk cadangan',
    learnMore: 'Pelajari lebih lanjut'
  },
  tpImport: {
    title: 'Impor dompet TP',
    description: 'Siapkan mnemonik atau kunci privat dompet Anda. Anda dapat mulai menggunakan setelah impor.'
  },
  tpWallet: {
    title: 'Impor dompet',
    tabMnemonic: 'Mnemonik',
    tabPrivateKey: 'Kunci privat',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Masukkan kata mnemonik sesuai urutan, dipisahkan dengan spasi',
    placeholderPrivateKey: 'Masukkan kunci privat',
    placeholderKeystore: 'Masukkan konten Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'Nama chain',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Mode lanjutan >',
    agreementPrefix: 'Saya telah membaca dan menyetujui ',
    serviceAgreement: 'Perjanjian layanan',
    confirmImport: 'Konfirmasi impor'
  },
  tronlinkImport: {
    title: 'Impor dompet',
    description:
      'Masukkan mnemonik, kunci privat, atau konten file Keystore untuk memulihkan atau memindahkan dompet. Kami tidak menyimpan informasi kunci privat Anda.'
  },
  tronlinkWallet: {
    title: 'Impor dompet',
    placeholder: 'Masukkan mnemonik atau kunci privat'
  },
  metamask: {
    importTitle: 'Impor dompet',
    subTitle: 'Masukkan frasa pemulihan di sini',
    placeholder: 'Pisahkan setiap kata dengan spasi dan pastikan tidak ada yang melihat.',
    wordHint: 'Gunakan huruf kecil saja, periksa ejaan, dan pertahankan urutan kata asli.',
    continue: 'Lanjutkan',
    sheetTitle: 'Apa itu frasa pemulihan rahasia?',
    sheetP1:
      'Frasa pemulihan rahasia (juga disebut mnemonik) adalah kumpulan kata yang memungkinkan Anda mengakses dan mengontrol dompet kripto. Anda memerlukannya untuk memindahkan dompet ke MetaMask.',
    sheetListTitle: 'Siapa pun dengan frasa pemulihan rahasia Anda dapat:',
    sheetL1: 'Mengambil semua dana Anda',
    sheetL2: 'Mengonfirmasi transaksi',
    sheetL3: 'Mengubah informasi login Anda',
    gotIt: 'Mengerti'
  },
  trust: {
    headerTitle: 'Dompet multi-koin',
    walletName: 'Nama dompet',
    defaultWalletName: 'Dompet utama 1',
    mnemonicLabel: 'Frasa pemulihan',
    tips: 'Biasanya 12 kata (kadang 18 atau 24), dipisahkan dengan satu spasi',
    invalidMnemonic: 'Frasa pemulihan tidak valid'
  },
  okx: {
    title: 'Masukkan frasa pemulihan atau kunci privat',
    placeholder: 'Jika mengimpor dengan frasa pemulihan, pisahkan setiap kata dengan spasi'
  }
};
